<template>
  <button
    v-if="
      !priceTableStore.isFavoriteOptionSelected &&
      Object.keys(filterStore.filters).length > 0
    "
    type="button"
    class="mt-3 flex w-full items-center justify-between border-y border-gray-lightest py-2"
    @click="priceTableStore.togglePriceFilterPopup()"
  >
    <span class="text-left text-sm">
      <b>{{ $t('general.price_table.filters.chosen_filters') }}</b>
      {{ priceTableStore.selectedFiltersString }}
    </span>
    <FontAwesomeIcon :icon="{ prefix: 'fas', iconName: 'chevron-right' }" />
  </button>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { usePriceTableStore } from '@/stores/PriceTable/PriceTableStore.ts';
import { useFilterStore } from '@/stores/Configurator/FilterStore.ts';

const filterStore = useFilterStore();
const priceTableStore = usePriceTableStore();
</script>
